import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=84e2d6c0&scoped=true&"
import script from "./GenerateReport.vue?vue&type=script&lang=js&"
export * from "./GenerateReport.vue?vue&type=script&lang=js&"
import style0 from "./GenerateReport.vue?vue&type=style&index=0&id=84e2d6c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e2d6c0",
  null
  
)

export default component.exports